// A strict null check, not a falsy one: a stored score of 0 is a real score and
// must export as '0.0' rather than as unrated.
export const scoreExportVal = (score: number | null | undefined): string =>
  score === null || score === undefined ? 'Unrated' : score.toFixed(1);
